export const appHasError = state => state.errors.appHasError;

export const getErrorTitle = state => state.errors.errorTitle;

export const getErrorMessage = state => state.errors.errorMsg;



/** WEBPACK FOOTER **
 ** ./src/redux/selectors/errors.js
 **/